<template>
  <div class="min-h-screen flex flex-col">
    <div class="grid-bg" />
    <TopNav />
    <main class="app-main relative z-10 flex-1 max-w-[1400px] mx-auto w-full px-4 md:px-8 py-6 md:py-8">
      <slot />
    </main>
    <BottomTabBar />
  </div>
</template>

<script setup>
import TopNav from './TopNav.vue';
import BottomTabBar from './BottomTabBar.vue';
</script>

<style scoped>
/* Reserve room for the BottomTabBar (visible up to 1280px) so last cards never get clipped */
.app-main { padding-bottom: calc(7rem + env(safe-area-inset-bottom)); }
@media (min-width: 1280px) {
  .app-main { padding-bottom: 2rem; }
}
</style>
